import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { onEvent } from '../lib/ws';

export default function Wallboard() {
  const { data: snap, refetch } = useQuery({
    queryKey: ['wallboard'],
    queryFn: () => api.wallboard.snapshot(),
    refetchInterval: 5_000,
  });
  const [live, setLive] = useState<any>(null);

  useEffect(() => {
    const off = onEvent('wallboard.snapshot', (data) => setLive(data));
    return () => off();
  }, []);

  const data = live || snap;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Wallboard</h1>
        <button onClick={() => refetch()} className="btn-ghost text-sm">Refresh</button>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Stat label="Active Calls"        value={data?.active_calls ?? '—'} />
        <Stat label="Registered Phones"   value={data?.registered_extensions ?? '—'} />
        <Stat label="Avg MOS (1h)"        value={data?.quality?.avg ?? '—'} />
      </div>
      <h2 className="text-lg font-semibold mt-6">Queues</h2>
      <div className="grid grid-cols-2 gap-4">
        {(data?.queues || []).map((q: any) => (
          <div key={q.queue_uuid} className="card">
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold">{q.name}</h3>
              <span className="text-xs text-textSecondary">ext {q.extension}</span>
            </div>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <Mini label="Agents (avail / total)" value={`${q.agents_available ?? 0} / ${q.agents_total ?? 0}`} />
              <Mini label="Callers waiting" value={q.callers_waiting ?? 0} />
              <Mini label="Avg wait (s)" value={q.avg_wait_seconds ?? 0} />
              <Mini label="On call" value={q.agents_on_call ?? 0} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: any }) {
  return (
    <div className="card text-center">
      <div className="text-textSecondary text-sm">{label}</div>
      <div className="text-4xl font-semibold mt-2">{value}</div>
    </div>
  );
}
function Mini({ label, value }: { label: string; value: any }) {
  return (
    <div>
      <div className="text-textSecondary text-xs">{label}</div>
      <div className="font-mono text-base">{value}</div>
    </div>
  );
}
